module.exports = __webpack_public_path__ + "img/contacts.675e88dd.jpg";